import { Eye } from "lucide-react";
import { InlineActionButton } from "@/components/ui/InlineActionButton";

type DefaultAlertActionsProps = {
  canMarkSeen: boolean;
  isBusy: boolean;
  onMarkSeen: () => void;
};

export function DefaultAlertActions({
  canMarkSeen,
  isBusy,
  onMarkSeen,
}: DefaultAlertActionsProps) {
  return (
    <>
      {canMarkSeen && (
        <InlineActionButton
          onClick={onMarkSeen}
          disabled={isBusy}
          icon={<Eye size={12} />}
        >
          Marcar visto
        </InlineActionButton>
      )}
    </>
  );
}
